module.exports = __webpack_public_path__ + "img/emoji_80.a0d8edcc.png";